import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import { TreasuryDoc, treasuryDefaults, TREASURY_CSS } from "@/pages/TreasuryRepo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Public, token-signed print route for headless-Chrome PDF rendering / eFax.
export default function PrintTreasury() {
  const { appId } = useParams();
  const t = new URLSearchParams(useLocation().search).get("t");
  const [app, setApp] = useState(null);
  const [shared, setShared] = useState(null);

  useEffect(() => {
    if (!appId || !t) return;
    (async () => {
      try {
        const r = await axios.get(`${API}/borrower/applications/${appId}/public?t=${encodeURIComponent(t)}`);
        const a = r.data.application || {};
        const saved = a.treasury_doc_settings || {};
        const acctMap = {};
        const v = a.loan_account_no || a.account_no || a.loan_number || "";
        if (v) acctMap[a.id] = v;
        setShared({ ...treasuryDefaults(), ...saved, acct: { ...acctMap, ...(saved.acct || {}) } });
        setApp(a);
      } catch { /* leave blank */ }
    })();
  }, [appId, t]);

  if (!app || !shared) return <div style={{ padding: 40, fontFamily: "serif" }}>Loading…</div>;
  return (
    <div style={{ background: "#fff" }}>
      <div className="cm-print-area">
        <TreasuryDoc app={app} shared={shared} last />
      </div>
      <style>{TREASURY_CSS}</style>
    </div>
  );
}
